module.exports = __webpack_public_path__ + "img/user_icon.99fa1fd8.svg";